import React from "react";
import "../../css/pp-sect1.css";
import Ill1LG from "../../assets/images/parentPage-sect1-img1-lg.png";
import Ill1SM from "../../assets/images/parentPage-sect1-img1-sm.png";
import Ill2LG from "../../assets/images/parentPage-sect1-img2-lg.png";
import Ill2SM from "../../assets/images/parentPage-sect1-img2-sm.png";
import Ill3LG from "../../assets/images/parentPage-sect1-img3-lg.png";
import Ill3SM from "../../assets/images/parentPage-sect1-img3-sm.png";

const Sect1 = () => {
  return (
    <section id="pp-sect1">
      <div>
        <div>
          <figure>
            <img className="pp-ill-lg" src={Ill1LG} alt="" />
            <img className="pp-ill-sm" src={Ill1SM} alt="" />
          </figure>
          <article>
            <h2>
              You can know what they are learning and how they are learning it
            </h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
        <div>
          <figure>
            <img className="pp-ill-lg" src={Ill2LG} alt="" />
            <img className="pp-ill-sm" src={Ill2SM} alt="" />
          </figure>
          <article>
            <h2>
              Personalised study time-tables to help them prepare effectively
            </h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
        <div>
          <figure>
            <img className="pp-ill-lg" src={Ill3LG} alt="" />
            <img className="pp-ill-sm" src={Ill3SM} alt="" />
          </figure>
          <article>
            <h2>
              Hundreds of subject/ courses from teachers in top schools around
              the world
            </h2>
            <p>
              Our landing page template works on all devices, so you only have
              to set it up once, and get beautiful results.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Sect1;
